import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ModifierEditPageRBAC = {
  pageID: '7b2b75c6e692208ed4e3be1920d89698',
  elementID: {},
} as const

export const useRBACModifierEditPage = createUseRBAC(ModifierEditPageRBAC.elementID)

export type UseRBACModifierEditPageType = ReturnType<typeof useRBACModifierEditPage>
